import { getLinkedFirm } from "../../sessionStorage/sessionStorage";
import {
  useGetCustomFieldsQuery,
  useGetCustomFieldValuesQuery,
} from "../../slices/CustomFieldsSlice";
import { CustomFieldEntity } from "./customFields.types";
import { filledCustomFields } from "./customFields.utils";

/** A client's custom fields that have a value, for its info card. */
export const useFilledCustomFields = (
  customerId: string | null | undefined,
  entityType: CustomFieldEntity,
) => {
  const orgId = getLinkedFirm()?.orgId || "";
  const { data: fields } = useGetCustomFieldsQuery({ orgId }, { skip: !orgId });
  const { data: values } = useGetCustomFieldValuesQuery(
    { customerId: customerId || "" },
    { skip: !customerId },
  );
  return filledCustomFields(fields, entityType, values);
};
